import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ChannelService, ChatClientService} from 'stream-chat-angular';
import {debounceTime, of, tap} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {DefaultLayoutAlignDirective, DefaultLayoutDirective, DefaultLayoutGapDirective} from 'ngx-flexible-layout';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatInput} from '@angular/material/input';
import {MatIconButton, MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatFormField} from '@angular/material/form-field';
import {MerchandiserGetStream} from '../../../shared/models/getstream/merchandiser-get-stream.model';
import {AssociateService} from '../../../core/services/associates.service';
import {LoginService} from '../../../core/services/login.service';
import {MsgBannerService} from '../../../shared/components/msg-banner/services/msg-banner.service';

@Component({
  selector: 'app-add-channel',
  imports: [
    MatDialogContent,
    DefaultLayoutAlignDirective,
    DefaultLayoutDirective,
    DefaultLayoutGapDirective,
    MatAutocomplete,
    MatOption,
    ReactiveFormsModule,
    MatInput,
    MatIconButton,
    MatButton,
    MatAutocompleteTrigger,
    MatIcon,
    MatFormField
  ],
  templateUrl: './add-channel.component.html',
  styleUrl: './add-channel.component.scss',
})
export class AddChannelComponent implements OnInit {

  form: UntypedFormGroup;
  filteredUsers: MerchandiserGetStream[] = [];

  user: MerchandiserGetStream = null;

  constructor(private dialogRef: MatDialogRef<AddChannelComponent>,
              private associateSvc: AssociateService,
              public getStreamSvc: ChatClientService,
              private loginSvc: LoginService,
              private msgBanner: MsgBannerService,
              public channelService: ChannelService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.form = new UntypedFormGroup({
      searchBy: new UntypedFormControl(null, [])
    });
  }

  ngOnInit(): void {
    this.form.controls['searchBy'].valueChanges.pipe(
      debounceTime(300),
      tap(),
      switchMap(value => {
          if (value?.length < 3) {
            this.filteredUsers = [];
            return of(null);
          }
          if (value instanceof Object || value === '' || !value) {
            return of(null);
          }
          return this.associateSvc.autocompleteUsers(value);
        }
      )
    ).subscribe((users) => {
      this.filteredUsers = users;
    });
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  createChannel(user: MerchandiserGetStream) {
    this.user = user;
  }

  onSubmit() {

    const channel = this.getStreamSvc.chatClient.channel('messaging', {
      members: [ this.loginSvc._eid, this.user.eid ]
    });
    channel.create().then(async (res) => {
      await channel.watch();
      this.channelService.setAsActiveChannel(channel);
      await channel.show();
      this.dialogRef.close(this.user);
    }).catch(err => {
      console.error(err);

      this.msgBanner.addMsgError("Chat couldn't be created. Please contact your administrator.");
    });
  }

  validateForm() {
    return !this.user;
  }
}
